<mat-sidenav-container style="background-color: #5C6BC0; height: 100%;">
    <div style="display: flex; justify-content: center; align-items: center;" class="h-100">
        <div class="no-select login-containercontrol">
            <div style="text-align:center;"> <img src="assets/img/NexusLogo.png" alt="login_logo"></div>
            <div class="login_titlecontainer">
                <h1 class="login_title">{{'Login.Title' | translate}}</h1>
            </div>
            <br/>

            <mat-card>
                <mat-toolbar class="login-toolbar" color="primary">{{'Login.Header' | translate}}</mat-toolbar>

                <mat-card-content style="display:flex; flex-direction:column; justify-content:end; align-items:center; padding: 16px;"
                    class="box-content">
                    <form [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">

                        <mat-error *ngIf="loginError">{{'General.Application.Messages.LOGIN_ERROR' |
                            translate}}</mat-error>
                        <mat-slide-toggle class="w-100" formControlName="IsADUser">
                            <div class="checkbox_text">
                                {{ 'Login.User.IsADUser' | translate }}
                            </div>
                        </mat-slide-toggle>
                        <mat-form-field appearance="outline" class="w-100">
                            <img matPrefix src="assets/img/ic_person_outline.png" alt="person">
                            <input #name autofocus type="text" matInput
                                placeholder="{{ 'Login.User.Name' | translate }}" formControlName="Name">
                            <mat-error *ngIf="loginForm.controls.Name.errors?.required">
                                {{'General.Application.Messages.USERNAME_REQUIRED' | translate}}</mat-error>
                            <mat-error *ngIf="loginForm.controls.Name.hasError('minlength')">
                                {{'General.Application.Messages.USERNAME_MINLENGTH' | translate}}</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                            <img matPrefix src="assets/img/ic_lock_outline.png" alt="">
                            <input type="password" autocomplete="false" matInput
                                placeholder="{{ 'General.Password' | translate }}" formControlName="Password"  trim="blur" [type]="hidePassword ? 'password' : 'text'">
                            <mat-icon matSuffix class="placeholder myClickable my-noselect" style="margin-right: 10px;"
                                (click)="toggleHidePassword()">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="loginForm.controls.Password.errors?.required">
                                {{'General.Application.Messages.PASSWORD_REQUIRED' | translate}}</mat-error>
                            <mat-error *ngIf="loginForm.controls.Password.hasError('minlength')">
                                {{'General.Application.Messages.PASSWORD_MINLENGTH' | translate}}</mat-error>
                        </mat-form-field>
                        <button type="submit" mat-raised-button color="primary" (click)="login()"
                            [disabled]="!loginForm.valid">{{'Login.Button.Text' | translate}}</button>
                    </form>
                </mat-card-content>
            </mat-card>

        </div>

    </div>

</mat-sidenav-container>